// extracted by mini-css-extract-plugin
module.exports = {"container":"navbarOnboarding_container__3j6O9","backButton":"navbarOnboarding_backButton__3qzv5"};